import { fetcher } from '@commenda/utils';

export interface UpdateAdminCompanyAiAccessParams {
  companyId: number;
  isEnabled: boolean;
}

export interface UpdateAdminCompanyAiAccessResponse {
  isAiEnabled: boolean;
}

export async function updateAdminCompanyAiAccess({
  companyId,
  isEnabled,
}: UpdateAdminCompanyAiAccessParams): Promise<UpdateAdminCompanyAiAccessResponse> {
  const response = await fetcher(`admin/companies/${companyId}/ai-access`, {
    method: 'PATCH',
    body: { isEnabled },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to update AI access';
    throw new Error(message);
  }

  return response.json();
}
